import {
  EyeOutlined,
  FieldTimeOutlined,
  HourglassOutlined,
  StopOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { CheckCircleOutlined } from '@ant-design/icons';
import { colors } from 'theme/colors';

import CircleOutlined from 'components/icons/CircleOutlined';

import {
  TaskActorStatus,
  TaskStatus,
  StatusConfig,
} from 'types/task/TaskCommon';

export const preparerStatusConfig: Record<TaskActorStatus, StatusConfig> = {
  BLOCKED: {
    Icon: StopOutlined,
    text: 'Blocked',
    bgColor: colors.red1,
    contentColor: colors.red5,
    borderColor: colors.red3,
  },
  TODO: {
    Icon: CircleOutlined,
    text: 'To do',
    bgColor: colors.mauveGrey1,
    contentColor: colors.mauveGrey7,
    borderColor: colors.mauveGrey3,
  },
  IN_PROGRESS: {
    Icon: SyncOutlined,
    text: 'In Progress',
    bgColor: colors.cyan1,
    contentColor: colors.cyan7,
    borderColor: colors.cyan3,
  },
  COMPLETED: {
    Icon: CheckCircleOutlined,
    text: 'Completed',
    bgColor: colors.subtleMint2,
    contentColor: colors.subtleMint7,
    borderColor: colors.subtleMint4,
  },
} as const;

export const reviewerStatusConfig: Record<TaskActorStatus, StatusConfig> = {
  BLOCKED: {
    ...preparerStatusConfig.BLOCKED,
    text: 'In Preparation',
    Icon: FieldTimeOutlined,
  },
  TODO: {
    text: 'Ready for Review',
    Icon: HourglassOutlined,
    bgColor: colors.lime1,
    contentColor: colors.lime7,
    borderColor: colors.lime3,
  },
  IN_PROGRESS: {
    text: 'In Review',
    Icon: EyeOutlined,
    bgColor: colors.gold1,
    contentColor: colors.gold7,
    borderColor: colors.gold3,
  },
  COMPLETED: preparerStatusConfig.COMPLETED,
} as const;

export const taskStatusConfig: Record<TaskStatus, StatusConfig> = {
  BLOCKED: preparerStatusConfig.BLOCKED,
  TODO: preparerStatusConfig.TODO,
  IN_PREPARATION: preparerStatusConfig.IN_PROGRESS,
  READY_FOR_REVIEW: reviewerStatusConfig.TODO,
  IN_REVIEW: reviewerStatusConfig.IN_PROGRESS,
  COMPLETED: preparerStatusConfig.COMPLETED,
} as const;
